import { FC } from 'react'
import { App } from './App'

export const DiscoverApp: FC = () => <App />
